import styled, { css } from 'styled-components'

export const BackToTopButtonRoot = styled.button`
  position: fixed;
  right: ${({ $isMobile }) => ($isMobile ? '16px' : '24px')};
  bottom: ${({ $bottomOffset }) => `${$bottomOffset}px`};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: ${({ $isMobile }) => ($isMobile ? '8px' : '6px 8px')};
  min-width: ${({ $isMobile }) => ($isMobile ? '32px' : 'auto')};
  min-height: 32px;
  border: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.neutralW20};
  color: ${({ theme }) => theme.colors.neutralW100};
  z-index: 2;
  transition:
    opacity 180ms ease,
    transform 180ms ease,
    background-color 180ms ease,
    border-color 180ms ease;

  ${({ $isVisible }) =>
    $isVisible
      ? css`
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        `
      : css`
          opacity: 0;
          transform: translateY(6px);
          pointer-events: none;
        `}

  &:hover {
    background: ${({ theme }) => theme.colors.neutralW30};
  }

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.interact70};
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`

export const BackToTopLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
`
